export default __webpack_public_path__ + "images/0x4200000000000000000000000000000000000042.png";